import { Button } from '@mui/material';
import { Edit } from '@mui/icons-material';

interface EditButtonProps {
  onClick: () => void;
  text: string;
}

/**
 * Standardized Edit button for operations.
 */
export default function EditButton({ 
  onClick, 
  text 
}: EditButtonProps) {
  return (
    <Button 
      variant="outlined" 
      color="primary" 
      size="medium"
      onClick={onClick}
      startIcon={<Edit />}
    >
      {text}
    </Button>
  );
}